import React, { useState } from 'react';
import * as S from './TitleBar.styles';

const TitleBar = () => {

  return (
    <S.TitleWrap>
      <h2>Reports & GST Invoice</h2>
    </S.TitleWrap>
  );
};

export default TitleBar;
